<template>
  <b-container>
      <b-card class="mb-4">
        <b-row>
            <b-col>
              <vue-element-loading :active="loading" text="Obteniendo información ..." spinner="bar-fade-scale" />
                <div class="row mb-md-2">
                    <div class="col-sm-12 col-md-6">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Mostrar
                                <b-form-select
                                    v-model="perPage"
                                    size="sm"
                                    class="ml-1 mr-1"
                                    :options="pageOptions"
                                ></b-form-select
                                > Clientes
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <label class="d-inline-flex align-items-center">
                                Buscar:
                                <b-form-input
                                    v-model="filter"
                                    type="search"
                                    placeholder="Filtra buscando aquí"
                                    class="form-control form-control-sm ml-2"
                                ></b-form-input>
                            </label>
                        </div>
                    </div>
                    <!-- End search -->
                </div>
                <b-table
                  :items="paymentList"
                  :fields="fields"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  @row-clicked="rowClicked"
                  show-empty
                  empty-text="Sin datos para mostrar"
                  hover
                  responsive = "true"
                  head-variant="light" style="overflow-x:auto">
                  <template #cell(actions)="data">
                    <a :href="data.item.payment_info.support_file_url" target="_blank" class="btn btn-sm btn-primary">Descargar</a>
                    </template>
                </b-table>
                <div class="row">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-right"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
      </b-card>

  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import axios from 'axios'

const API_BASE_URL = 'https://us-central1-atpro-app.cloudfunctions.net/api'

export default {
  name: 'Listado PAgos',
  data () {
    return {
      loading: false,
      perPage: 10,
      currentPage: 1,
      data: [],
      filter: null,
      filterOn: [],
      pageOptions: [10, 25, 50, 100],
      fields: [
        { key: 'company_info.name', label: 'Empresa', sortable: true },
        { key: 'payment_info.plan_name', label: 'Nombre plan', sortable: false },
        { key: 'payment_info.active', label: 'Activo', sortable: true,  formatter: (value) => {
          return this.translateStatus(value);
        }},
        { key: 'payment_info.status', label: 'Estado', sortable: true,  formatter: (value) => {
          return this.translateSuscription(value);
        } },
        { key: 'actions', label: 'Acciones' }
      ],
      paymentList: [],
      tableKey: 1
    }
  },
  computed: {
    rows () {
      return this.data.length || 0
    },
  },
  methods: {
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    async getManagersList() {
      this.loading = true;
      let companyData = JSON.parse(localStorage.getItem("atpro_cd"));
      const {data: { data }} = await axios.get(`${API_BASE_URL}/supportPayments/all`)
      console.log(data)
      this.paymentList = data.map(e => {
            return e
          })
      this.loading = false;
    },

    addManager() {
      console.log("add professional")
      this.$router.push({ name:  'atpro.managers-add' })
    },

    managersDetail(key) {
      this.$router.push({ name: 'atpro.managers-edit', params:{key} });
    },

   async deleteProfessionals(id){
        let success = await axios.delete(`${API_BASE_URL}/manager/delete/${id}`);
        if(success){
            await this.getManagersList();
        }
    },

    translateSuscription(status){
      let statusSelected = '';
      switch(status){
          case 'pending':
            statusSelected = 'Pendiente';
            break;
          
          case 'accepted':
            statusSelected = 'Aprobado'
            break;
          
          case 'rejected':
            statusSelected = 'Rechazado'
            break;
      }

      return statusSelected;
    },

    translateStatus(status){
      let statusSelected = '';
      switch(status){
          case true:
            statusSelected = 'Si';
            break;
          
          case false:
            statusSelected = 'No'
            break;
      }

      return statusSelected;
    },
    
   
    rowClicked (row) {
      console.log(row)
    },
  },
  mounted () {
    core.index()
    this.getManagersList()
  }
}
</script>
<style scoped>
tr{
  cursor: pointer !important;
}
.mr10{
  margin-right: 10px;
}
  
</style>